<template>
  <div v-if="shouldShowSidebar" class="sidebar">
    <nav class="sidebar-nav">
      <div>&nbsp;</div>
      <ul
        class="nav"
        v-if="isMenuDefault"
      >
        <li class="nav-item">
          <router-link
            :to="{ name: 'PaginaInicial' }"
            class="nav-link"
            ><i class="fas fa-home"></i>
            {{ $lang.Menu.Items.StartPage }}</router-link
          >
        </li>
        <li
          class="nav-item"
          v-if="!hasRole(roles.USUARIO_EXTERNO) && modules.hasAssociado"
        >
          <router-link
            :to="{ name: 'Associate' }"
            class="nav-link"
            ><i class="fas fa-users"></i> Associados</router-link
          >
        </li>
        <li
          class="nav-item"
          v-if="hasKanban && modules.hasCrm"
        >
          <router-link
            :to="{ name: 'CRMModular' }"
            class="nav-link"
            exact
            :class="{
              active:
                !$route.params.tipoQuadro &&
                $route.path.toLowerCase().includes('crm')
            }"
            ><i class="fas fa-address-card"></i> CRM</router-link
          >
        </li>
        <li
          class="nav-item"
          v-if="hasKanban && modules.hasAjuizamento"
        >
          <router-link
            :to="{ name: 'CRMModular', params: { tipoQuadro: 'ajuizamento' } }"
            class="nav-link"
            ><i class="fas fa-balance-scale"></i> Ajuizamento</router-link
          >
        </li>
        <li
          class="nav-item nav-dropdown"
          v-if="hasKanban && modules.hasCobranca"
        >
          <div
            class="nav-link nav-dropdown-toggle"
            @click.prevent="handleClick"
          >
            <i class="fas fa-file-invoice-dollar"></i> Cobrança
          </div>
          <ul class="nav-dropdown-items">
            <li
              class="nav-item"
              v-if="hasKanban && modules.hasCobranca"
            >
              <router-link
                :to="{ name: 'CRMModular', params: { tipoQuadro: 'cobranca' } }"
                class="nav-link"
                ><i class="fa fa-caret-right"></i> CRM</router-link
              >
            </li>
            <li class="nav-item">
              <router-link
                :to="{ name: 'Cobrança' }"
                class="nav-link"
                exact
                ><i class="fa fa-caret-right"></i> Gerenciar
                Cobrança</router-link
              >
            </li>
            <li class="nav-item">
              <router-link
                :to="{ name: 'CobrançaUpdates' }"
                class="nav-link"
                exact
                ><i class="fa fa-caret-right"></i> Ver Atualizações</router-link
              >
            </li>
          </ul>
        </li>
        <li
          id="campanhas"
          class="nav-item nav-dropdown"
          v-if="
            modules.hasCampanha &&
            !hasRole(roles.USUARIO_EXTERNO) &&
            (hasRole(roles.ADMINISTRADOR) || hasRole(roles.ACESSO_CAMPANHA))
          "
        >
          <div
            class="nav-link nav-dropdown-toggle"
            @click.prevent="handleClick"
          >
            <i class="fas fa-bullhorn"></i> Campanha
          </div>
          <ul class="nav-dropdown-items">
            <li class="nav-item">
              <router-link
                :to="{ name: 'Campanha' }"
                class="nav-link"
                exact
                ><i class="fa fa-caret-right"></i> Gerenciar
                Campanha</router-link
              >
            </li>
            <li class="nav-item">
              <router-link
                :to="{ name: 'RedeSocial' }"
                class="nav-link"
                exact
                ><i class="fa fa-caret-right"></i> Rede Social</router-link
              >
            </li>
            <li
              id="blocklist"
              class="nav-item nav-dropdown"
              v-if="
                modules.hasCampanha &&
                !hasRole(roles.USUARIO_EXTERNO) &&
                (hasRole(roles.ADMINISTRADOR) || hasRole(roles.ACESSO_CAMPANHA))
              "
            >
              <div
                class="nav-link"
                @click.prevent="toggleChild('blocklist__container')"
              >
                <i class="fa fa-caret-right caret-direction-blocklist__container"></i>
                BlockList
              </div>
              <div class="blocklist__container d-none">
                <li class="nav-item">
                  <router-link
                    :to="{ name: 'BlockListEmail' }"
                    class="nav-link deep-item"
                    exact
                  >
                    <i class="fa fa-caret-right"></i> Email
                  </router-link>
                </li>
                <li class="nav-item">
                  <router-link
                    :to="{ name: 'BlockListWhatsApp' }"
                    class="nav-link deep-item"
                    exact
                  >
                    <i class="fa fa-caret-right"></i> WhatsApp
                  </router-link>
                </li>
              </div>
            </li>
          </ul>
        </li>
        <!-- Menu Modelos (inclui HSM) -->
        <li
          id="modelos"
          class="nav-item nav-dropdown"
          v-if="
            !hasRole(roles.USUARIO_EXTERNO) &&
            (hasRole(roles.ADMINISTRADOR) || hasRole(roles.ACESSO_CAMPANHA))
          "
        >
          <div
            class="nav-link nav-dropdown-toggle"
            @click.prevent="handleClick"
          >
            <i class="fas fa-th-large"></i> Modelos
          </div>
          <ul class="nav-dropdown-items">
            <li class="nav-item">
              <router-link
                :to="{ name: 'ModeloCampanha' }"
                class="nav-link"
                exact
                ><i class="fa fa-caret-right"></i> Campanha</router-link
              >
            </li>
            <li class="nav-item">
              <router-link
                :to="{ name: 'Hsm' }"
                class="nav-link"
                exact
                ><i class="fa fa-caret-right"></i> HSM</router-link
              >
            </li>
          </ul>
        </li>
        <li
          class="nav-item"
          v-if="modules.hasVisitas"
        >
          <router-link
            :to="{ name: 'Visitas' }"
            class="nav-link"
            ><i class="fas fa-map-marked-alt"></i> Visitas</router-link
          >
        </li>
        <!-- <router-link :to="{ name: 'Campanha' }" class="nav-link"><i class="fas fa-bullhorn"></i> Campanha <b-badge variant="primary">Novo</b-badge></router-link> -->
        <li
          class="nav-item"
          v-if="hasRole(roles.IMPORTACAO_PLANILHA) && modules.hasImportacao"
        >
          <router-link
            :to="{ name: 'Importacao' }"
            class="nav-link"
            ><i class="fas fa-file-import"></i> Importação</router-link
          >
        </li>
        <div v-if="hasAtendimento">
          <li
            v-if="
              hasRole('OPERADOR_ATENDIMENTO_GERAL') ||
              hasRole('OPERADOR_ATENDIMENTO') ||
              hasRole('GESTOR_ATENDIMENTO')
            "
            id="atendimento"
            class="nav-item nav-dropdown"
          >
            <div
              class="nav-link nav-dropdown-toggle"
              @click.prevent="handleClick"
            >
              <i class="fas fa-headset"></i> Atendimento
            </div>
            <ul class="nav-dropdown-items">
              <li class="nav-item">
                <router-link
                  :to="{ name: 'Atendimento' }"
                  class="nav-link"
                  exact
                  ><i class="fa fa-caret-right"></i> Conversas</router-link
                >
              </li>
              <li class="nav-item">
                <router-link
                  :to="{ name: 'Ligacoes' }"
                  class="nav-link"
                  exact
                  ><i class="fa fa-caret-right"></i> Ligacoes</router-link
                >
              </li>
              <li
                v-if="hasRole('OPERADOR_ATENDIMENTO')"
                class="nav-item"
              >
                <router-link
                  :to="{ name: 'CentralAtendimento' }"
                  class="nav-link"
                  exact
                  ><i class="fa fa-caret-right"></i> Central PA</router-link
                >
              </li>
              <li
                v-if="hasRole('OPERADOR_ATENDIMENTO_GERAL')"
                class="nav-item"
              >
                <router-link
                  :to="{ name: 'CentralAtendimentoGeral' }"
                  class="nav-link"
                  exact
                  ><i class="fa fa-caret-right"></i> Central Geral</router-link
                >
              </li>
              <li class="nav-item">
                <router-link
                  :to="{ name: 'HistoricoAtendimento' }"
                  class="nav-link"
                  exact
                  ><i class="fa fa-caret-right"></i> Histórico</router-link
                >
              </li>
              <li
                class="nav-item"
                v-if="hasRole('GESTOR_ATENDIMENTO')"
              >
                <router-link
                  :to="{ name: 'RelatorioAtendimento' }"
                  class="nav-link"
                  exact
                  ><i class="fa fa-caret-right"></i> Relatório</router-link
                >
              </li>
              <li
                v-if="hasRole('GESTOR_ATENDIMENTO')"
                class="nav-item"
              >
                <router-link
                  :to="{ name: 'MetricaAtendimento' }"
                  class="nav-link"
                  exact
                  ><i class="fa fa-caret-right"></i> Métricas</router-link
                >
              </li>
            </ul>
          </li>
        </div>
        <li
          v-if="hasRole(roles.ACESSO_RELATORIOS) && modules.hasRelatorios"
          id="campanhas"
          class="nav-item nav-dropdown"
        >
          <div
            class="nav-link nav-dropdown-toggle"
            @click.prevent="handleClick"
          >
            <i class="fas fa-chart-bar"></i> Relatórios
          </div>
          <ul class="nav-dropdown-items">
            <li
              class="nav-item"
              v-if="modules.hasCrm"
            >
              <router-link
                :to="{ name: 'RelatorioCrm' }"
                class="nav-link"
                exact
                ><i class="fa fa-caret-right"></i> CRM</router-link
              >
            </li>
            <li
              v-if="modules.hasAjuizamento"
              class="nav-item"
            >
              <router-link
                :to="{ name: 'RelatorioAjuizamento' }"
                class="nav-link"
                exact
                ><i class="fa fa-caret-right"></i> Ajuizamento</router-link>
            </li>
            <li
              class="nav-item"
              @click="toggleChild('relatorioFollowUp__container')"
            >
              <div class="nav-link">
                <i
                  class="fa fa-caret-right caret-direction-relatorioFollowUp__container"
                ></i>
                Follow-Up
              </div>
            </li>
            <div class="relatorioFollowUp__container d-none">
              <li class="nav-item">
                <router-link
                  :to="{ name: 'RelatorioCrmActions' }"
                  class="nav-link deep-item"
                  exact
                  ><i class="fa fa-caret-right"></i> Ações CRM</router-link
                >
              </li>
              <li class="nav-item">
                <router-link
                  :to="{ name: 'RelatorioFollowUp' }"
                  class="nav-link deep-item"
                  exact
                  ><i class="fa fa-caret-right"></i> Ocorrências</router-link
                >
              </li>
            </div>
            <li
              class="nav-item"
              @click="toggleChild('relatorioVisitas__container')"
              v-if="modules.hasVisitas"
            >
              <div class="nav-link">
                <i
                  class="fa fa-caret-right caret-direction-relatorioVisitas__container"
                ></i>
                Visitas
              </div>
            </li>
            <div class="relatorioVisitas__container d-none">
              <li class="nav-item">
                <router-link
                  :to="{ name: 'RelatorioDeslocamento' }"
                  class="nav-link deep-item"
                  exact
                  ><i class="fa fa-caret-right"></i> Deslocamento</router-link
                >
              </li>
              <li class="nav-item">
                <router-link
                  :to="{ name: 'RelatorioDespesas' }"
                  class="nav-link deep-item"
                  exact
                  ><i class="fa fa-caret-right"></i> Despesas</router-link
                >
              </li>
              <li class="nav-item">
                <router-link
                  :to="{ name: 'RelatorioAcompanhamento' }"
                  class="nav-link deep-item"
                  exact
                  ><i class="fa fa-caret-right"></i>Acompanhamento</router-link
                >
              </li>
            </div>
            <li
              v-if="hasRole(roles.ACESSO_CAMPANHA) && modules.hasCampanha"
              class="nav-item"
              @click="toggleChild('relatorioCampanha__container')"
            >
              <div class="nav-link">
                <i
                  class="fa fa-caret-right caret-direction-relatorioCampanha__container"
                ></i>
                Campanha
              </div>
            </li>
            <div class="relatorioCampanha__container d-none">
              <li class="nav-item">
                <router-link
                  :to="{ name: 'RelatorioCampanha' }"
                  class="nav-link deep-item"
                  exact
                  ><i class="fa fa-caret-right"></i> Campanhas</router-link
                >
              </li>
              <li class="nav-item">
                <router-link
                  :to="{ name: 'ReportEnvioCampanha' }"
                  class="nav-link deep-item"
                  exact
                  ><i class="fa fa-caret-right"></i> Envios de
                  Campanha</router-link
                >
              </li>
            </div>
            <li class="nav-item">
              <router-link
                :to="{ name: 'RelatorioMovimentacaoCards' }"
                class="nav-link d-flex align-items-center"
                exact
              >
                <i class="fa fa-caret-right mr-2"></i>
                <span>Movimentação de Cards</span>
              </router-link>
            </li>
          </ul>
        </li>
        <li class="nav-item">
          <router-link
            :to="{ name: 'Anexos' }"
            class="nav-link"
            ><i class="fas fa-paste"></i> Repositório de Anexos</router-link
          >
        </li>
        <li
          class="nav-item nav-dropdown"
          v-if="hasRole(roles.ADMINISTRADOR)"
        >
          <div
            class="nav-link nav-dropdown-toggle"
            @click.prevent="handleClick"
          >
            <i class="fas fa-clipboard-list"></i> Auditoria
          </div>
          <ul class="nav-dropdown-items">
            <li class="nav-item">
              <router-link
                :to="{ name: 'LogsUsuarios' }"
                class="nav-link"
                exact
                ><i class="fa fa-caret-right"></i> Log de usuários</router-link
              >
            </li>
            <li class="nav-item">
              <router-link
                :to="{ name: 'LogsTags' }"
                class="nav-link"
                exact
                ><i class="fa fa-caret-right"></i> Log de Tags</router-link
              >
            </li>
          </ul>
        </li>
        <li
          class="nav-item"
          v-if="!hasRole(roles.USUARIO_EXTERNO)"
          @click="onShowSidebarSetting"
        >
          <a class="nav-link"><i class="fas fa-cogs"></i> Cadastros</a>
        </li>

        <li
          class="nav-item"
          v-for="(item, index) in myLinks"
          :key="index"
        >
          <a
            class="nav-link"
            :href="onGetUrl(item.url)"
            target="_blank"
            ><i :class="item.icon"></i> {{ item.nome }}</a
          >
        </li>

        <li class="divider"></li>
        <li class="pt-5">&nbsp;</li>
      </ul>
      <SidebarSetting
        ref="SidebarSetting"
        v-show="isMenuSetting"
        @BackMenu="onBackMenu"
      />
    </nav>
  </div>
</template>
<script>
import Roles from '@/shared/utils/roles.js'
// import PermissionMixin from '@/store/module/permission/mixin'
import LinksRepository from '@/shared/http/repositories/configurations/links.js'
import ActionForms from '@/shared/mixins/actionsForm.js'
import ModulesLite from '@/shared/mixins/modulesLite'
import { JWTService } from '@/shared/services/jwt'
import { loading, toast } from '@/shared/utils/UIHelper'
import AccountMixin from '@/store/module/account/mixin'
import SidebarSetting from './sidebars/SidebarSettings.vue'
// import Tools from '@/components/tools/Tools.js'
// import { actionTypes as AccountActions } from '@/store/module/account/actions'

export default {
  name: 'sidebarApp',
  mixins: [AccountMixin, ActionForms, ModulesLite],
  data () {
    return {
      tShieldClient: process.env.TShieldClient,
      hasKanban: process.env.hasKanban,
      roles: Roles,
      permissions: null,
      myLinks: [],
      isMenuDefault: true,
      isMenuSetting: false,
      isMenuSettingAtendimento: false,
      hasAtendimento: process.env.hasAtendimento
    }
  },
  components: {
    SidebarSetting
  },
  mounted () {
    /*
    this[AccountActions.GET_LOGGED]()
      .then((response) => {
      })
    */
    this.permissions = JWTService.GetRoles()
    this.onLoadAllLinks()
  },
  computed: {
    shouldShowSidebar () {
      const hiddenRoutes = ['Totem', 'Tv']
      return !hiddenRoutes.includes(this.$route.name)
    }
  },
  methods: {
    onLoad () {},
    handleClick (e) {
      const current = e.target.closest('.nav-dropdown')
      if (!current) return

      const submenu = current.querySelector('.nav-dropdown-items')
      const isOpen = current.classList.contains('open')

      const siblings = current.parentElement.children
      for (let element of siblings) {
        if (element !== current && element.classList.contains('open')) {
          element.classList.remove('open')
          const sub = element.querySelector('.nav-dropdown-items')
          if (sub) {
            sub.style.maxHeight = ''
            sub.style.overflowY = ''
          }
        }
      }

      if (isOpen) {
        current.classList.remove('open')
        if (submenu) {
          submenu.style.maxHeight = ''
          submenu.style.overflowY = ''
        }
      } else {
        current.classList.add('open')
        if (submenu) {
          if (submenu.scrollHeight > 216) {
            submenu.style.maxHeight = '216px'
            submenu.style.overflowY = 'auto'
          } else {
            submenu.style.maxHeight = ''
            submenu.style.overflowY = ''
          }
        }
      }
    },
    toggleChild (e) {
      // e.preventDefault()
      document.querySelector('.' + e).classList.toggle('d-none')
      document
        .querySelector('.caret-direction-' + e)
        .classList.toggle('caret-direction-bottom')
    },
    RemoveMinimizedSidebar: function () {
      document.body.classList.remove('sidebar-minimized')
      window.scrollTo(0, 0)
    },
    hasRole (role) {
      var result = false
      if (this.permissions) {
        for (var i in this.permissions) {
          // if (this.permissions[i].role === role) {
          if (this.permissions[i] === role) {
            result = true
          }
        }
      }
      return result
    },
    onBackMenu () {
      this.RemoveMinimizedSidebar()
      this.isMenuDefault = true
      this.isMenuSetting = false
    },
    onShowSidebarSetting () {
      this.RemoveMinimizedSidebar()
      this.isMenuSetting = true
      this.isMenuDefault = false
    },
    onLoadAllLinks () {
      loading.push()
      LinksRepository.GetAll()
        .then((response) => {
          this.myLinks = response.data.content
          loading.close()
        })
        .catch((err) => {
          if (
            err.message === 'Unauthorized' ||
            err.message === 'ExpiredToken' ||
            err.message ===
              "Cannot read properties of undefined (reading 'status')"
          ) {
            toast.error(this.$lang.Common.SessionEnded)
          } else {
            toast.error(this.$lang.Common.MicroserviceUnavailable)
          }
          loading.pop()
        })
    },
    onGetUrl (value) {
      let result = ''
      const url = value
      if (value && value.substring(0, 4) === 'http') {
        result = url
      } else {
        result = 'http://' + url
      }
      return result
    }
  }
}
</script>

<style lang="css">
.nav-link {
  cursor: pointer;
}
.nav-dropdown-toggle:hover,
.nav-dropdown:hover {
  right: 50;
}
.caret-direction-bottom {
  transition: transform 0.15s ease-in-out;
  transform: rotate(90deg);
}
.deep-item {
  margin-left: 1rem !important;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
</style>



// WEBPACK FOOTER //
// src/containers/layout/Sidebar.vue